import React, { Fragment } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {
    Alert, Button, Col, Row,
} from 'react-bootstrap';
import Gallery from 'react-grid-gallery';

import { ControlPageBlock, InputField } from '../blocks/edit_blocks';
import Fetcher from '../common/communicate';
import { PROJECT_PREFIX } from '../const';
import reorder from '../tools/reorder-list';

export default class PollEditScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            current_poll: '',
            imageList: [
                {
                    src: '//vkplay.ru/hotbox/content_files/common/poll_pics/AdobeStock_202182934.svg',
                    thumbnail: '//vkplay.ru/hotbox/content_files/common/poll_pics/AdobeStock_202182934.svg',
                    isSelected: false,
                    thumbnailWidth: 120,
                    thumbnailHeight: 120,
                },
                {
                    src: '//vkplay.ru/hotbox/content_files/common/poll_pics/AdobeStock_221523377.svg',
                    thumbnail: '//vkplay.ru/hotbox/content_files/common/poll_pics/AdobeStock_221523377.svg',
                    isSelected: false,
                    thumbnailWidth: 120,
                    thumbnailHeight: 120,
                },
                {
                    src: '//vkplay.ru/hotbox/content_files/common/poll_pics/AdobeStock_231187324.svg',
                    thumbnail: '//vkplay.ru/hotbox/content_files/common/poll_pics/AdobeStock_231187324.svg',
                    isSelected: false,
                    thumbnailWidth: 120,
                    thumbnailHeight: 120,
                },
                {
                    src: '//vkplay.ru/hotbox/content_files/common/poll_pics/AdobeStock_248789559.svg',
                    thumbnail: '//vkplay.ru/hotbox/content_files/common/poll_pics/AdobeStock_248789559.svg',
                    isSelected: false,
                    thumbnailWidth: 120,
                    thumbnailHeight: 120,
                },
            ],
        };

        this.handleChange = this.handleChange.bind(this);

        this.handleData = this.handleData.bind(this);
        this.pickImage = this.pickImage.bind(this);
        this.sendData = this.sendData.bind(this);

        this.goToNewPage = this.goToNewPage.bind(this);
        this.goToPreviousPage = this.goToPreviousPage.bind(this);
        this.removeData = this.removeData.bind(this);

        this.savePollAnswer = this.savePollAnswer.bind(this);
        this.pollHandleChange = this.pollHandleChange.bind(this);
        this.priorityHandleChange = this.priorityHandleChange.bind(this);
        this.removeAnswerHandler = this.removeAnswerHandler.bind(this);

        if (props.match.params.id) {
            this.state.API_ENDPOINT = `poll/${props.match.params.id}/`;
        } else {
            this.state.API_ENDPOINT = 'poll/';
        }
    }

    validate() {
        const no_valid_fields = {};
        const req_fields = ['title'];

        for (let i = 0; i < Object.keys(req_fields).length; i++) {
            if (!this.state.data[req_fields[i]]) {
                no_valid_fields[req_fields[i]] = true;
            }
        }

        Object.assign(no_valid_fields, this.state.not_valid);
        this.setState({ not_valid: no_valid_fields });
    }

    sendData(event) {
        this.validate();
        let request_method = 'PUT';

        if (!this.props.match.params.id) {
            request_method = 'POST';
        }

        const save_type = event.currentTarget.id;
        let callback = this.handleData;

        if (save_type === 'save_button') {
            callback = this.goToPreviousPage;
        }

        if (!this.props.match.params.id) {
            callback = this.goToNewPage;
        }

        Fetcher(this.state.API_ENDPOINT, request_method, callback, this.state.data);
    }

    handleData(data) {
        const imlist = this.state.imageList;

        for (let i = 0; i < imlist.length; i++) {
            if (imlist[i].src === data.background) {
                imlist[i].isSelected = true;
            } else {
                imlist[i].isSelected = false;
            }
        }

        this.setState({ loading: false, data, imageList: imlist });
    }

    goToNewPage(newData) {
        this.setState({ API_ENDPOINT: `poll/${newData.id}/`, data: { ...this.state.data, id: newData.id } });
        this.props.history.push(`${PROJECT_PREFIX}/poll/${newData.id}/edit`);
    }

    goToPreviousPage() {
        this.props.history.push(`${PROJECT_PREFIX}/poll/all`);
    }

    removeData() {
        Fetcher(this.state.API_ENDPOINT, 'DELETE', this.goToPreviousPage);
    }

    handleChange(event) {
        const state = event.currentTarget.value;
        const new_state = this.state;
        new_state.data[event.currentTarget.id] = state;
        this.setState(new_state);
    }

    pollHandleChange(event) {
        const state = event.currentTarget.value;
        this.setState({ current_poll: state });
    }

    priorityHandleChange(event) {
        const state = event.currentTarget.value;
        this.setState({ current_priority: state });
    }

    removeAnswerHandler(event) {
        Fetcher(
            `poll/${this.props.match.params.id}/answers/${event.currentTarget.id}/`,
            'DELETE',
            this.handleData,
        );
    }

    componentDidMount() {
        if (this.props.match.params.id) {
            Fetcher(this.state.API_ENDPOINT, 'GET', this.handleData);
        } else {
            this.setState({
                loading: false, data: {},
            });
        }
    }

    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const items = reorder(
            this.state.data.answers,
            result.source.index,
            result.destination.index,
        );

        this.setState({
            data: {
                ...this.state.data,
                answers: items,
            },
        });
    };

    getCurrentResults(state) {
        if (!state.data.answers) {
            return;
        }

        if (state.data.answers.length === 0) {
            return;
        }

        const html_results_list = [];

        for (let i = 0; i < state.data.answers.length; i++) {
            html_results_list.push(
                <Draggable key={state.data.answers[i].id} draggableId={state.data.answers[i].id} index={i}>
                    {(provided) => (
                        <div
                            className="poll-item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            <p>{state.data.answers[i].text}</p>
                            <Button
                                size="sm"
                                variant="link"
                                id={state.data.answers[i].id}
                                to="#"
                                onClick={this.removeAnswerHandler}
                            >
                                <FontAwesomeIcon id={state.data.answers[i].id} icon="trash" />
                            </Button>
                        </div>
                    )}
                </Draggable>,
            );
        }

        return (
            <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (

                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {html_results_list}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        );
    }

    savePollAnswer() {
        Fetcher(`poll/${this.props.match.params.id}/answers/`, 'POST', (data) => {
            this.handleData(data);
            this.setState({ current_poll: '' });
        }, { text: this.state.current_poll, priority: this.state.current_priority || -1000 });
    }

    resultsBlock() {
        if (!this.props.match.params.id) {
            return (
                <Col md={8}><Alert variant="warning">Для работы с блоком результатов сохраните опрос</Alert></Col>
            );
        }

        return (
            <>
                <Row className="mt-2 d-flex align-items-end">
                    <Col md={11}>
                        <InputField
                            name="text"
                            label="Новый ответ"
                            value={this.state.current_poll}
                            onChange={this.pollHandleChange}
                            maxLength={100}
                            required
                        />
                    </Col>
                    <Col md={1}>
                        <Button onClick={this.savePollAnswer} variant="outline-dark" block>
                            <FontAwesomeIcon
                                icon="plus"
                            />
                        </Button>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col md={6}>
                        {this.getCurrentResults(this.state)}
                    </Col>
                </Row>
            </>
        );
    }

    pickImage(image) {
        const imlist = this.state.imageList;

        for (let i = 0; i < imlist.length; i++) {
            if (i !== image) {
                imlist[i].isSelected = false;
            } else if (imlist[i].isSelected) {
                imlist[i].isSelected = false;
            } else {
                imlist[i].isSelected = true;
            }
        }

        const { data } = this.state;
        data.background = imlist[image].src;
        this.setState({ imageList: imlist, data });
    }

    render() {
        return (
            <div className="container-fluid">
                <Row className="mt-2">
                    <Col md={6}>
                        <h4>Опрос</h4>
                    </Col>
                </Row>
                <Row className="show-grid mt-4">
                    <Col md={8}>
                        <InputField
                            name="title"
                            label="Заголовок"
                            value={this.state.data.title}
                            onChange={this.handleChange}
                            maxLength={100}
                            required
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={8}>
                        {this.resultsBlock()}
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col md={8}>
                        <h4>Фон</h4>
                        <Gallery
                            images={this.state.imageList}
                            onSelectImage={this.pickImage}
                            onClickThumbnail={this.pickImage}
                            rowHeight={240}
                        />
                    </Col>
                </Row>

                <ControlPageBlock
                    name={this.state.data.name}
                    onSave={this.sendData}
                    onApply={this.sendData}
                    onCancel={this.goToPreviousPage}
                    onRemove={this.removeData}
                    onReject={false}
                />
            </div>
        );
    }
}
